module.exports = {
      id: "fallback-image-usage",
      viewBox: "0 0 102 76",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#fallback-image",
      toString: function () {
        return this.url;
      }
    }